import { isObjectRecord } from "../../typeGuards";
import { ArsListingVariable } from "../interface";

/**
 * Type guard for ArsListingVariable.
 *
 * @param obj - The parameter to check
 * @returns True if the parameter is an ArsListingVariable, false otherwise
 */
export const isArsListingVariable = (obj: unknown): obj is ArsListingVariable => {
  if (!isObjectRecord(obj)) return false;

  if (typeof obj.id !== "string") return false;
  if (typeof obj.dataset !== "string") return false;
  if (typeof obj.variable !== "string") return false;
  if (
    typeof obj.variableType !== "string" ||
    !["displayOnly", "group", "hidden-sort-ascending", "hidden-sort-descending"].includes(
      obj.variableType,
    )
  )
    return false;

  // Everything is good
  return true;
};
